import { callCollaboratorsApi } from './collaboratorsApi';

interface AddCollaboratorResult {
  success: boolean;
  collaborator: {
    uid: string;
    email: string | null;
    displayName: string | null;
  };
}

export async function addCollaborator(
  tourId: string,
  email: string,
): Promise<AddCollaboratorResult> {
  return callCollaboratorsApi<AddCollaboratorResult>({
    action: 'add',
    tourId,
    email,
  });
}
